import script from "./UploadsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadsTab.vue?vue&type=script&setup=true&lang=js"

import "./UploadsTab.vue?vue&type=style&index=0&id=2aa59181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa59181"]])

export default __exports__